import { AlertCircle, CheckCircle, Info, X } from "lucide-react";
import T from "../theme/colors";

export default function Alert({ type = "error", message, onClose }) {
  if (!message) return null;
  const TYPES = {
    error:   { bg: "var(--danger-bg)",  bdr: "var(--danger-bdr)",  color: "var(--danger)",  Icon: AlertCircle },
    success: { bg: "var(--success-bg)", bdr: "var(--success-bdr)", color: "var(--success)", Icon: CheckCircle },
    info:    { bg: "var(--info-bg)",    bdr: "var(--info-bdr)",    color: "var(--info)",    Icon: Info        },
    warn:    { bg: "var(--warn-bg)",    bdr: "var(--warn-bdr)",    color: "var(--warn)",    Icon: AlertCircle },
  };
  const { bg, bdr, color, Icon } = TYPES[type] || TYPES.error;
  return (
    <div style={{
      display: "flex", alignItems: "flex-start", gap: 10,
      background: bg, border: `1px solid ${bdr}`,
      borderRadius: 7, padding: "10px 14px", marginBottom: 16,
    }}>
      <Icon size={15} style={{ color, flexShrink: 0, marginTop: 1 }} />
      <span style={{ fontSize: 15, color, flex: 1, lineHeight: 1.5 }}>{message}</span>
      {onClose && (
        <button onClick={onClose} style={{ background: "none", border: "none", color, cursor: "pointer", display: "flex", padding: 2 }}>
          <X size={13} />
        </button>
      )}
    </div>
  );
}
